export default __webpack_public_path__ + "static/media/jigsaw-lady.9f6058bd.svg";